var getRGBfromHex = function getRGBfromHex(hex) {
  // if it's a 3 char hex, convert to 6
  if (hex.replace('#', '').length === 3) {
    hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
  }
  return {
    red: parseInt(hex.slice(1, 3), 16),
    green: parseInt(hex.slice(3, 5), 16),
    blue: parseInt(hex.slice(5, 7), 16)
  };
};
var getLumenValue = function getLumenValue(color) {
  var lumen = 0;
  if (color <= 0.03928) {
    lumen = color / 12.92;
  } else {
    lumen = Math.pow((color + 0.055) / 1.055, 2.4);
  }
  return lumen;
};
var calculateLuminosity = function calculateLuminosity(color) {
  var _getRGBfromHex = getRGBfromHex(color),
    red = _getRGBfromHex.red,
    green = _getRGBfromHex.green,
    blue = _getRGBfromHex.blue;
  red = getLumenValue(red / 255);
  green = getLumenValue(green / 255);
  blue = getLumenValue(blue / 255);
  return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
};
var calculateLuminosityRatio = function calculateLuminosityRatio(color1, color2) {
  var lum1 = calculateLuminosity(color1);
  var lum2 = calculateLuminosity(color2);
  var ratio = 0;
  if (lum1 > lum2) {
    ratio = (lum1 + 0.05) / (lum2 + 0.05);
  } else {
    ratio = (lum2 + 0.05) / (lum1 + 0.05);
  }
  return ratio;
};
var isContrastRatioAACompliant = function isContrastRatioAACompliant(color1, color2) {
  return calculateLuminosityRatio(color1, color2) >= 4.5;
};
var isValidHexString = function isValidHexString(color) {
  return !!color && color !== '#' && color.match(/^(#)?([0-9a-fA-F]{6}|[0-9a-fA-F]{3})?$/) !== null;
};
var addHashToColorIfNeeded = function addHashToColorIfNeeded(colorString) {
  if (colorString !== '' && colorString.charAt(0) !== '#') {
    return "#".concat(colorString);
  }
  return colorString;
};
export { addHashToColorIfNeeded, getRGBfromHex, isContrastRatioAACompliant, isValidHexString };